module.exports = __webpack_public_path__ + "img/avatar1.ddd40aa5.png";